import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"dense":""}},[_c(VCol,{attrs:{"cols":"9","md":"11"}},[_c('h6',{},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c(VCol,{staticClass:"text-right",attrs:{"cols":"3","md":"1"}},[_vm._t("titleAction")],2),_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"BlueCardBorder px-3 py-2",attrs:{"rounded":"lg","outlined":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }